// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zwzFj","disabled":"styles_disabled__x_Gv5"};